import Head from "next/head";
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Heading,
  Text,
  Grid,
  GridItem,
  Link as ChakraLink,
} from "@chakra-ui/react";
import Chatbot from "./chatbot";
import Link from "next/link";
import Customerservicebot from "./customerservicesbot";

const CareerPage = () => {
  const emailAddress = "contactus@unlimiteye.com";
  const [userType, setUserType] = useState(null);

  useEffect(() => {
    const role = sessionStorage.getItem("userType");
    setUserType(role);
  }, []);

  return (
    <>
      <Head>
        <title>Aptofy | AI based recruitment </title>

        <link rel="canonical" href="https://aptofy.com/" key="canonical" />
        <link rel="canonical" href="https://www.aptofy.com/" key="canonical" />

        <link
          href="https://fonts.googleapis.com/css2?family=Caveat:wght@700&display=swap"
          rel="stylesheet"
        />
        <meta title="Join Aptofy's Dynamic Team | Careers in AI-Powered Recruitment Solutions"></meta>

        <meta
          content="Explore exciting career opportunities at Aptofy, a leading provider of AI-powered recruitment solutions. Join our dynamic team and contribute to revolutionizing the hiring process"
          name="description"
        />

        <meta name="rating" CONTENT="General" />
        <meta content="all" name="Googlebot-Image" />
        <meta content="all" name="Slurp" />
        <meta content="all" name="Scooter" />
        <meta content="ALL" name="WEBCRAWLERS" />
        <meta name="revisit-after" CONTENT="2 days" />
        <meta name="robots" content=" ALL, index, follow" />
        <meta name="robots" content=" ALL, index, follow" />
        <meta name="distribution" content="Global" />
        <meta name="rating" content="Safe For All" />
        <meta name="language" content="English" />
        <meta http-equiv="window-target" content="_top" />
        <meta http-equiv="pics-label" content="for all ages" />
        <meta name="rating" content="general" />
        <meta content="All, FOLLOW" name="GOOGLEBOTS" />
        <meta content="All, FOLLOW" name="YAHOOBOTS" />
        <meta content="All, FOLLOW" name="MSNBOTS" />
        <meta content="All, FOLLOW" name="BINGBOTS" />

        {/* header icon  */}
        <link
          rel="icon"
          type="image/png"
          sizes="180x180"
          href="/assets/aptofy.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/assets/aptofy.svg"
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/assets/aptofy.png"
        />
        <link rel="mask-icon" href="/static/favicon-mask.svg" color="#000000" />
      </Head>
      {/* To show different chat bot for loged user and guest user */}
      {userType === '"candidate"' || userType === '"recruiter"' ? (
        <Customerservicebot />
      ) : (
        <Chatbot />
      )}

      <Box p={4}>
        <Heading as="h1" mb={4} textAlign={"center"} color={"#3B58D7"}>
        The Aptofy Career Path
        </Heading>

        <Text mb={4} fontSize={"2xl"} textAlign={"center"}>
       
Embrace the opportunity to work with cutting-edge technologies like AI, ML, 
and innovative Cloud-based solutions. Join a team of visionaries transforming talent
 acquisition and unlock your potential in a dynamic and impactful environment.
        </Text>

       {/* Career Boxes */}
<Box borderWidth="1px" borderRadius="lg" overflow="hidden" p={4} mt={8}>
  <Grid 
    templateColumns={{ base: "1fr", md: "1fr 1fr", lg: "1fr 1fr 1fr" }} 
    gap={4} 
    mt={9}
  >
    <GridItem
      borderBottom="1px solid #E2E8F0"
      borderRight={{ base: "none", md: "1px solid #E2E8F0" }}
      pb={4}
      textAlign="center"
      minHeight="160px"
    >
      <Heading as="h3" size="lg" mb={2}>
        Business Development Manager - Sales
      </Heading>
      <Text mb={2}>Experience: 5+ years</Text>
      <Text mb={4}>
        Join our dynamic sales team and help us grow our business with
        your expertise.
      </Text>
      <ChakraLink as={Link} href="/signUp" passHref>
        <Button colorScheme="blue">Apply Now</Button>
      </ChakraLink>
    </GridItem>
    <GridItem
      borderBottom="1px solid #E2E8F0"
      borderRight={{ base: "none", md: "1px solid #E2E8F0" }}
      pb={4}
      textAlign="center"
    >
      <Heading as="h3" size="lg" mb={2}>
        AI/ML Engineer
      </Heading>
      <Text mb={2}>Experience: 3+ years</Text>
      <Text mb={4}>
        Be a part of our AI/ML team to develop cutting-edge machine
        learning models.
      </Text>
      <ChakraLink as={Link} href="/signUp" passHref>
        <Button colorScheme="blue">Apply Now</Button>
      </ChakraLink>
    </GridItem>
    <GridItem
      borderBottom={{ base: "1px solid #E2E8F0", md: "none" }}
      pb={4}
      textAlign="center"
    >
      <Heading as="h3" size="lg" mb={2}>
        Frontend Developer - ReactJS
      </Heading>
      <Text mb={2}>Experience: 2+ years</Text>
      <Text mb={4}>
        Work with our frontend team to build stunning web applications
        using ReactJS.
      </Text>
      <ChakraLink as={Link} href="/signUp" passHref>
        <Button colorScheme="blue">Apply Now</Button>
      </ChakraLink>
    </GridItem>
  </Grid>
</Box>


        <Text as="h2" mb={4} textAlign={"center"}>
          To explore our current job openings,{" "}
          <Link href="/signUp" style={{ color: "#3B58D7" }}>
            Sign Up
          </Link>{" "}
          to Aptofy.
        </Text>
        {/* Add your career website link here */}
        <Text textAlign={"center"}>
          Send your Resume to{" "}
          <a href={`mailto:${emailAddress}`}>{emailAddress}</a>
        </Text>
      </Box>
    </>
  );
};

export default CareerPage;
